import type { Patient } from 'src/app/types';

export const getFullName = (patient: Patient | Partial<Patient>) =>
  patient && patient?.firstName && patient?.lastName ? `${patient.firstName} ${patient.lastName}` : '';
